import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col } from "react-bootstrap";
import bannerImage from "../../Images/International/international-partnership-banner.webp";
import { Link } from "react-router-dom";
import diu from "../../Images/MOU/diu-logo.webp";
import indiana from "../../Images/MOU/indiana-logo.webp";
import rushford from "../../Images/MOU/rushford-logo.webp";
import henry from "../../Images/MOU/henry-logo.webp";
import acc from "../../Images/accrediations/aacsb.webp";
import iau from "../../Images/accrediations/iaou.webp";

const InternationalPartnerships = () => {
  return (
    <>
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>International Partnerships</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <Link
                    to="/"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Global Collaborations
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          {/* Introduction Section */}
          <Row className="justify-content-center mb-5">
            <Col lg={4}>
              <img src={acc} alt="Sports Activities" class="health-image" />
            </Col>
            <Col lg={8}>
              <div className="section-intro ps-3">
                <h2 className="section-title-start modern-title">
                  AACSB – Global Standard for Business Education
                </h2>
                <p>
                  ISBM University is associated with the Association to Advance
                  Collegiate Schools of Business (AACSB), the world’s leading
                  accrediting body for business schools. AACSB represents
                  excellence in management education across 100+ countries and
                  sets the benchmark for innovation, research, and student
                  success.
                </p>
                <p>
                  By aligning with AACSB standards, ISBM University ensures that
                  its business and management programs meet global benchmarks of
                  quality. This recognition places ISBM among internationally
                  respected universities, enhancing academic value and career
                  opportunities.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          {/* Introduction Section */}
          <Row className="justify-content-center mb-5">
            <Col lg={8}>
              <div className="section-intro">
                <h2 className="section-title-start modern-title">
                  AIU – Association of Indian Universities Membership
                </h2>
                <p>
                  ISBM University is a proud member of the Association of Indian
                  Universities (AIU), a prestigious body that ensures national
                  and international equivalence of degrees. AIU plays a key role
                  in standardizing higher education in India and fostering
                  academic collaboration worldwide.
                </p>
                <p>
                  Through AIU membership, ISBM University students gain the
                  assurance that their degrees are valid, recognized, and
                  respected across India and abroad.
                </p>
              </div>
            </Col>
            <Col lg={4}>
              <img src={iau} alt="Sports Activities" class="health-image" />
            </Col>
          </Row>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          {/* Introduction Section */}
          <Row className="justify-content-center mb-5">
            <Col lg={12}>
              <div className="section-intro ">
                <h2 className="text-blue section-title modern-title text-center">
                  Global Academic Collaborations
                </h2>
                <p>
                  The primary objective of the International Tie-ups is to
                  promote internationalization and cross-cultural exchange in
                  the academic realm. These tie-ups are aimed at fostering
                  global academic and research opportunities for students,
                  faculty, and staff members of ISBM University.
                </p>
                <p>
                  Through these partnerships, ISBM University aims to provide
                  its students with exposure to global educational practices,
                  diverse perspectives, and a broader understanding of different
                  cultures. Additionally, it facilitates the exchange of
                  knowledge, research collaborations, and joint academic
                  programmes between ISBM University and its international
                  partners.
                </p>
              </div>
            </Col>
          </Row>

          {/* Partnership Cards */}
          <Row className="g-4 ">
            {/* Dresden International University */}
            <Col lg={12}>
              <div className="partnership-card bg-light p-4 p-lg-5 rounded-3 shadow border-start border-4 border-blue">
                <Row>
                  <Col lg={3} className="text-center mb-4 mb-lg-0">
                    <div className="university-logo-container logo-wrapper bg-white p-4 rounded-3 shadow">
                      <img
                        src={diu}
                        alt="Dresden International University"
                        className="img-fluid"
                      />
                    </div>
                  </Col>
                  <Col lg={9}>
                    <h2 className="text-blue fw-bold mb-3">
                      Dresden International University GmbH
                    </h2>
                    <p>
                      ISBM University has signed a MoU with Dresden
                      International University, Dresden, Germany. The MoU will
                      pave the way for students to enroll and get a
                      comprehensive knowledge and skills in market oriented
                      programmes such as MSC and MBA in Logistics Management,
                      International Commercial and Contract Management,
                      Industrial Management in Microelectronics, Non-Destructive
                      Testing, among others with work opportunities post-study
                      tenure.
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>

            {/* Rushford Business School */}
            <Col lg={12}>
              <div className="partnership-card bg-light p-4 p-lg-5 rounded-3 shadow border-start border-4 border-blue">
                <Row>
                  <Col lg={3} className="text-center mb-4 mb-lg-0">
                    <div className="university-logo-container logo-wrapper bg-white p-4 rounded-3 shadow">
                      <img
                        src={rushford}
                        alt="Rushford Business School"
                        className="img-fluid"
                      />
                    </div>
                  </Col>
                  <Col lg={9}>
                    <h2 className="text-blue fw-bold mb-3">
                      Rushford Business School
                    </h2>
                    <p>
                      ISBM University, in collaboration with Rushford Business
                      School, Switzerland, offers globally recognized MBA, MSc,
                      and Bachelor programs designed for future-ready
                      professionals. Students can earn a prestigious dual degree
                      from both institutions, gaining international exposure,
                      industry-relevant expertise, and leadership skills. With
                      specializations in areas such as Business Analytics, Data
                      Science & AI, Global Banking & Finance, Strategic
                      Leadership, and Healthcare Management, these programs
                      combine academic excellence with practical knowledge,
                      equipping learners for global career opportunities.
                    </p>
                    {/* <Link
                      to="/rushford-partnership"
                      className="btn btn-outline-purple mt-2"
                    >
                      Know more...
                    </Link> */}
                  </Col>
                </Row>
              </div>
            </Col>

            {/* Henry Harvin */}
            <Col lg={12}>
              <div className="partnership-card bg-light p-4 p-lg-5 rounded-3 shadow border-start border-4 border-blue">
                <Row>
                  <Col lg={3} className="text-center mb-4 mb-lg-0">
                    <div className="university-logo-container logo-wrapper bg-white p-4 rounded-3 shadow">
                      <img
                        src={henry}
                        alt="Henry Harvin"
                        className="img-fluid"
                      />
                    </div>
                  </Col>
                  <Col lg={9}>
                    <h2 className="text-blue fw-bold mb-3">Henry Harvin</h2>
                    <p>
                      ISBM University has signed a Memorandum of Understanding
                      (MoU) with Henry Harvin®, a global Edtech Company based
                      out of US and India, to conduct Training and Placement
                      programmes for its Students in over 600+ courses available
                      with the Edtech company like Six Sigma Green Belt,
                      Tableau, Analytics using Python/R (Business, Marketing,
                      HR, Finance), Blockchain Professional Course, Data Science
                      with Python Course, etc. The objective of the MoU is to
                      offer on-the-job training and practical training to
                      students of either diploma, graduation or post graduation
                      in any stream to enhance their employability and counter
                      the issues with respect to skilled labour scarcity in the
                      region.
                    </p>
                    {/* <Link
                      to="/henry-harvin-partnership"
                      className="btn btn-outline-purple mt-2"
                    >
                      Know more...
                    </Link> */}
                  </Col>
                </Row>
              </div>
            </Col>

            {/* Indiana Tech University */}
            <Col lg={12}>
              <div className="partnership-card bg-light p-4 p-lg-5 rounded-3 shadow border-start border-4 border-blue">
                <Row>
                  <Col lg={3} className="text-center mb-4 mb-lg-0">
                    <div className="university-logo-container logo-wrapper bg-white p-4 rounded-3 shadow">
                      <img
                        src={indiana}
                        alt="Indiana Tech University"
                        className="img-fluid"
                      />
                    </div>
                  </Col>
                  <Col lg={9}>
                    <h2 className="text-blue fw-bold mb-3">
                      Indiana Tech University
                    </h2>
                    <p>
                      Our partnership with Indiana Tech University reflects our
                      commitment to offering students a global learning
                      experience with access to world-class academic
                      opportunities. Through this collaboration, students can
                      explore Business Analytics and STEM MBA programs designed
                      to combine advanced technical knowledge with strategic
                      business skills. This partnership unlocks possibilities
                      such as international exchange programs, joint research
                      initiatives, and shared academic resources, providing
                      students from both institutions with a well-rounded,
                      future-ready education.
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default InternationalPartnerships;
